export const GENERIC = "generic";
export const APPLE = "apple";
export const FACEBOOK = "facebook";
export const GOOGLE = "google";
export const FIREBASE_NOTIFICATION = "firebaseNotification";
export const FULLSTORY = "fullstory";
